import { render, staticRenderFns } from "./alert-card.vue?vue&type=template&id=c9a75b78&scoped=true&"
import script from "./alert-card.component.ts?vue&type=script&lang=ts&"
export * from "./alert-card.component.ts?vue&type=script&lang=ts&"
import style0 from "./alert-card.vue?vue&type=style&index=0&id=c9a75b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a75b78",
  null
  
)

export default component.exports